module.exports = __webpack_public_path__ + "static/media/arrow-down-gray.cf42fad6.svg";